import { useMutation } from '/@/core/graphql'
import { gql } from '@apollo/client/core'

interface RecommendationInput {
  imageUrls: string[]
}

export function useRecommendationApi() {
  const { mutate: productRecommendations } = useMutation(gql`
    query productRecommendations($imageUrls: [String!]!) {
      recommendation {
        product(imageUrls: $imageUrls) {
          products {
            id
            thingType
            minPrice
            minPriceCent
            maxPrice
            maxPriceCent
            name
            isVerified
            category {
              id
              key
              name
            }
            images {
              id
              url
            }
            vendor {
              id
              name
              isVerified
            }
            matchedImageId
          }
        }
      }
    }
  `)

  return {
    async fetchProductRecommendations(input: RecommendationInput) {
      return await productRecommendations({ imageUrls: input.imageUrls })
    },
  }
}
